export default __webpack_public_path__ + "static/media/Sunset-at-Sirpur-lake-IndoreMP.ec65864c.jpg";